module.exports = __webpack_public_path__ + "media/components/assets/icons/link_arrow_light-c5d0e6d1f66aa4eb5317d8e5d25b5337.svg";